// Configuration for the 5 level landing pages. Each entry drives:
//  - the React <LevelLandingPage> component (H1, sections, CTAs)
//  - dynamic <Seo> tags (canonical/title/description/OG)
//  - backend prerender + sitemap entry
export const LEVEL_PAGES = {
  'espanol-a1': {
    level: 'A1',
    color: '#A8D8EA',
    fullTitle: 'Curso de Español A1 para Principiantes | Spanisch en la Red',
    title: 'Curso de Español A1 para Principiantes',
    seoDescription:
      'Aprende español desde cero con nuestro curso nivel A1. Clases online personalizadas para principiantes. ¡Empieza a hablar español hoy!',
    h1: 'Aprende Español desde Cero: Curso Nivel A1',
    tagline: 'Para adultos que nunca han estudiado español y quieren aprender de forma natural',
    intro:
      'Si nunca has estudiado español o llevas tiempo alejado del idioma, el nivel A1 es tu punto de partida. En 30 clases 1:1 pasarás de "no sé decir nada" a mantener conversaciones sencillas del día a día, presentarte, pedir en un restaurante, moverte por una ciudad hispanohablante o hablar de tu familia y trabajo.',
    outcomes: [
      { title: 'Presentarte con soltura', body: 'Nombre, edad, profesión, familia, aficiones — todo lo que necesitas para conocer gente.' },
      { title: 'Sobrevivir en un país hispanohablante', body: 'Pedir en un bar, comprar en el súper, preguntar direcciones, reservar hotel.' },
      { title: 'Presente de indicativo', body: 'Dominar el verbo más importante para hablar de tu día a día.' },
      { title: 'Vocabulario esencial (~500 palabras)', body: 'Los cimientos sobre los que se construye TODO el español.' },
    ],
    methodology: [
      'Clases 1:1 100% orales desde el minuto uno',
      'Materiales digitales incluidos (sin comprar libros caros)',
      'Adaptado a tu ritmo, sin presión de grupo',
      'Horarios flexibles adaptados a tu zona horaria',
    ],
    ctaHeadline: '¿Listo para dar el primer paso en español?',
    ctaText: 'Reserva tu clase de prueba GRATIS y define juntos tus objetivos.',
    ctaButton: 'Reservar clase de prueba gratis',
  },
  'espanol-a2': {
    level: 'A2',
    color: '#F5A6A4',
    fullTitle: 'Curso de Español A2 (Nivel Elemental) | Spanisch en la Red',
    title: 'Curso de Español A2 (Nivel Elemental)',
    seoDescription:
      'Consolida tus bases de español. Mejora tu vocabulario y fluidez básica en conversaciones cotidianas con nuestro curso nivel A2.',
    h1: 'Curso de Español Nivel A2: Consolida tus Bases',
    tagline: 'Para quienes ya se defienden en situaciones básicas y quieren fluidez real',
    intro:
      'En A2 ya sabes lo esencial, pero cuando la conversación se sale del guion te bloqueas. En este nivel aprenderás a hablar del pasado, hacer planes, describir experiencias y opinar de temas del día a día. Salimos de las frases hechas para construir tu propio español.',
    outcomes: [
      { title: 'Contar tu vida en pasado', body: 'Vacaciones, anécdotas, primer trabajo — con pretérito perfecto e indefinido.' },
      { title: 'Hacer planes y hablar del futuro', body: 'Ir a + infinitivo, futuro simple. Reservar, quedar, imaginar.' },
      { title: 'Describir personas y lugares', body: 'Personalidad, ciudades, casa, rutina, comparaciones básicas.' },
      { title: 'Vocabulario extendido (~1.500 palabras)', body: 'Salud, viajes, tiempo libre, trabajo, comidas típicas.' },
    ],
    methodology: [
      'Conversación guiada + corrección instantánea',
      'Ejercicios de comprensión con audios y textos reales',
      'Feedback escrito tras cada clase con puntos a mejorar',
      'Tests de progreso cada 5 clases',
    ],
    ctaHeadline: '¿Quieres pasar de A2 a B1 este trimestre?',
    ctaText: 'Reserva una clase gratis y hacemos juntos un plan a tu medida.',
    ctaButton: 'Empezar mi clase de prueba',
  },
  'espanol-b1': {
    level: 'B1',
    color: '#7DBDD9',
    fullTitle: 'Curso de Español B1 | Gana Fluidez y Confianza al Hablar',
    title: 'Curso de Español B1: Gana Fluidez y Confianza al Hablar',
    seoDescription:
      '¿Hablas español pero te atascas? Domina la conversación y la gramática intermedia con nuestras clases de español nivel B1.',
    h1: 'Curso de Español B1: Desarrolla tu Fluidez',
    tagline: 'Para adultos que quieren defenderse con soltura en el trabajo, viajes y relaciones sociales',
    intro:
      'B1 es el nivel que marca la diferencia entre "hablo un poco" y "sí, hablo español". Trabajaremos el subjuntivo (por fin), conectores para expresar tus ideas con precisión, el condicional para dar consejos y matizar, y todos los temas del examen DELE B1 si te interesa certificar tu nivel.',
    outcomes: [
      { title: 'Subjuntivo sin miedo', body: 'Presente y perfecto de subjuntivo — cuándo, por qué y para qué usarlos.' },
      { title: 'Conectores y argumentación', body: 'Sin embargo, aunque, siempre que… habla como un nativo educado.' },
      { title: 'Preparación DELE B1', body: 'Estructura del examen, criterios, ejercicios reales de comprensión y expresión.' },
      { title: 'Comprensión audiovisual', body: 'Podcasts, noticias, series — entender español real sin subtítulos.' },
    ],
    methodology: [
      'Debate y opinión en cada clase',
      'Feedback DELE-style (fluidez, alcance, corrección, coherencia)',
      'Simulacros de examen si preparas el DELE',
      'Materiales adaptados a tus intereses (trabajo, viajes, cultura...)',
    ],
    ctaHeadline: '¿Quieres alcanzar el B1 (o certificarlo con el DELE)?',
    ctaText: 'Reserva una clase gratuita y te doy un plan personalizado en 30 min.',
    ctaButton: 'Reservar mi clase de prueba',
  },
  'espanol-b2': {
    level: 'B2',
    color: '#F5A6A4',
    fullTitle: 'Curso de Español B2 (Intermedio Alto) | Spanisch en la Red',
    title: 'Curso de Español B2 (Intermedio Alto)',
    seoDescription:
      'Perfecciona tu español. Exprésate con seguridad en entornos personales y profesionales con nuestro curso nivel B2.',
    h1: 'Curso de Español B2: Perfeccionamiento y Expresión',
    tagline: 'Para quienes ya se comunican bien y buscan precisión, riqueza y naturalidad',
    intro:
      'En B2 dejamos de "estudiar español" y empezamos a "vivir en español". Trabajaremos matices que marcan la diferencia: subjuntivo en todos sus tiempos, estilo indirecto, discurso académico y coloquial, expresiones idiomáticas. Si vas a certificar el DELE B2, te preparo el examen a fondo.',
    outcomes: [
      { title: 'Subjuntivo avanzado', body: 'Imperfecto, pluscuamperfecto, correlación de tiempos. Precisión total.' },
      { title: 'Registro formal e informal', body: 'Del email corporativo a la charla con amigos, sin sonar rígido ni infantil.' },
      { title: 'Preparación DELE B2', body: '4 pruebas (comprensión, expresión escrita, oral, integradas). Simulacros completos.' },
      { title: 'Expresiones idiomáticas', body: '"Estar en las nubes", "meter la pata"… ese español que no está en los libros.' },
    ],
    methodology: [
      'Análisis de textos y audios de nivel B2/C1',
      'Redacciones semanales corregidas con anotaciones DELE',
      'Debates guiados sobre temas de actualidad',
      'Grabación de tus intervenciones para autoevaluación',
    ],
    ctaHeadline: '¿Preparas el DELE B2 o buscas fluidez avanzada?',
    ctaText: 'Reserva una clase gratis y hacemos una radiografía de tu nivel.',
    ctaButton: 'Probar una clase gratis',
  },
  'preparacion-dele': {
    level: 'DELE',
    color: '#7DBDD9',
    title: 'Preparación DELE online (A1–C2) con examinadora certificada',
    seoDescription:
      'Prepara tu examen DELE online con Cecilia Mateo, examinadora DELE certificada por el Instituto Cervantes. Simulacros, corrección personalizada y estrategias para las 4 pruebas. Reserva tu clase gratis.',
    h1: 'Preparación DELE online — con examinadora certificada por el Instituto Cervantes',
    tagline: 'A1 · A2 · B1 · B2 · C1 · C2 — plan a medida para superar tu examen',
    intro:
      'Como examinadora DELE certificada por el Instituto Cervantes, conozco por dentro qué se evalúa en cada prueba y qué errores suelen restar puntos. Te preparo el examen con simulacros reales, corrección detallada según los criterios oficiales y estrategias específicas por prueba (CL, CE, EE, EO).',
    outcomes: [
      { title: 'Diagnóstico inicial gratis', body: 'En la clase de prueba te digo qué nivel tienes hoy y qué necesitas mejorar.' },
      { title: 'Simulacros bajo condiciones reales', body: 'Cronómetro, formato oficial, criterios de corrección del Instituto Cervantes.' },
      { title: 'Estrategias por prueba', body: 'Comprensión lectora, auditiva, expresión escrita e interacción oral: técnicas concretas.' },
      { title: 'Corrección personalizada', body: 'Cada redacción y cada oral con feedback DELE-style + rúbricas oficiales.' },
    ],
    methodology: [
      'Materiales oficiales + banco privado de simulacros',
      'Rúbricas del Instituto Cervantes aplicadas en cada corrección',
      'Grabación de tus expresiones orales para revisión',
      'Plan de estudio semanal con hitos claros',
    ],
    ctaHeadline: '¿Tienes fecha de examen DELE? Vamos a organizarlo.',
    ctaText: 'Reserva una clase gratuita y te doy un plan de preparación personalizado.',
    ctaButton: 'Reservar diagnóstico DELE gratis',
  },
  'espanol-c1-c2': {
    level: 'C1-C2',
    color: '#4A4A4A',
    fullTitle: 'Clases de Español Avanzado (C1-C2) | Habla como un Nativo',
    title: 'Clases de Español Avanzado (C1-C2)',
    seoDescription:
      'Domina matices avanzados, expresiones idiomáticas y español profesional. Clases personalizadas de nivel avanzado.',
    h1: 'Español Avanzado (C1-C2): Domina el Idioma',
    tagline: 'Para hablantes de nivel avanzado que quieren precisión, riqueza léxica y sonar como un nativo',
    intro:
      'En los niveles C1 y C2 ya te comunicas con soltura, pero queda pulir los matices que separan a un buen hablante de uno excelente: registros, expresiones idiomáticas, argumentación compleja, español profesional y cultural. Diseñamos cada sesión alrededor de tus objetivos concretos —trabajo, academia, DELE C1/C2 o vida en un país hispanohablante.',
    outcomes: [
      { title: 'Registros y matices', body: 'Formal, informal, académico, coloquial — cambia de registro sin esfuerzo según el contexto.' },
      { title: 'Expresiones idiomáticas y locuciones', body: '"Estar en la luna", "tirar la casa por la ventana"… habla como un nativo educado.' },
      { title: 'Argumentación y debate', body: 'Estructura discursos, defiende ideas, contradice con elegancia y matiza opiniones.' },
      { title: 'Español profesional y académico', body: 'Correos, presentaciones, artículos, textos legales o técnicos según lo que necesites.' },
    ],
    methodology: [
      'Materiales de nivel C1/C2 (prensa, ensayo, literatura, podcasts)',
      'Redacciones y exposiciones orales corregidas con anotaciones precisas',
      'Simulacros DELE C1/C2 si preparas el examen',
      'Feedback personalizado sobre matices que sólo detecta una nativa',
    ],
    ctaHeadline: '¿Quieres pulir tu español y hablar con precisión nativa?',
    ctaText: 'Reserva una clase gratuita y hacemos un diagnóstico de tu nivel avanzado.',
    ctaButton: 'Reservar clase de prueba gratis',
  },
};
